import React, { useRef, useState, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import Button from "@material-ui/core/Button";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

const SignaturePad = (props) => {
  const { onSave, title, onClose } = props;
  const sigRef = useRef(null);
  const [signature, setSignature] = useState(null);

  // 👇 Force white background on init
  useEffect(() => {
    applyWhiteBackground();
  }, []);

  const applyWhiteBackground = () => {
    const canvas = sigRef.current?.getCanvas();
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  };

  const saveSignature = () => {
    if (sigRef.current.isEmpty()) {
      toast.error("Please provide a valid signature before saving.");
      return;
    }

    const dataURL = sigRef.current
      .getCanvas()
      .toDataURL("image/png");

    setSignature(dataURL);
    onSave(dataURL);
  };

  const clearSignature = () => {
    sigRef.current.clear();
    applyWhiteBackground(); // 👈 reapply white bg
    setSignature(null);
  };

  const downloadSignature = () => {
    if (!signature) return;

    const link = document.createElement("a");
    link.href = signature;
    link.download = "signature.png";
    link.click();
  };

  return (
    <div style={{ maxWidth: "600px" }}>
      <h3>{title || "Digital Signature"}</h3>

      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          marginBottom: "10px",
        }}
      >
        <SignatureCanvas
          ref={sigRef}
          penColor="black"
          canvasProps={{
            width: 500,
            height: 200,
            className: "sigCanvas",
          }}
        />
      </div>

      <div className="paginatorAlignRight">
        <Button
          disableElevation
          variant="contained"
          color="primary"
          onClick={saveSignature}
          className="ml-2"
        >
          Use Signature
        </Button>

        <Button
          disableElevation
          variant="outlined"
          color="primary"
          onClick={clearSignature}
          className="ml-2"
        >
          Clear
        </Button>

        <Button
          disableElevation
          variant="outlined"
          color="default"
          onClick={downloadSignature}
          disabled={!signature}
          className="ml-2"
        >
          Download
        </Button>
        <Button
          disableElevation
          variant="outlined"
          color="default"
          onClick={onClose}
          className="ml-2"
        >
          Close
        </Button>
      </div>
    </div>
  );
};

export default SignaturePad;

SignaturePad.propTypes = {
  onSave: PropTypes.func,
  title: PropTypes.string,
  onClose: PropTypes.func,
};
